import React from "react";
import { Helmet } from "react-helmet";
import { resourcesServices } from "../../services/resourcesService";
import ResourcesCommonComponent from "./ResourcesCommonComponent";
import { defer } from "react-router-dom";

const Ambulance = () => {
  return (
    <div>
      <div></div>
      <Helmet>
        <title>
          Availability Of Ambulance For Cancer Patients - Cope With Cancer
        </title>

        <meta
          name="description"
          content="Here is the list of ambulance services and their contact information for cancer patients in various areas within Mumbai, Maharashtra."
        />
        <meta name="robots" content="index,nofollow" />
        <link rel="canonical" href="https://www.copewithcancer.org/ambulance" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Availability Of Ambulance For Cancer Patients - Cope With Cancer"
        />
        <meta
          property="og:description"
          content="Here is the list of ambulance services and their contact information for cancer patients in various areas within Mumbai, Maharashtra."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/ambulance"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="Here is the list of ambulance services and their contact information for cancer patients in various areas within Mumbai, Maharashtra."
        />
        <meta
          name="twitter:title"
          content="Availability Of Ambulance For Cancer Patients - Cope With Cancer"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2016-06-06T09:53:51+00:00" />
      </Helmet>

      <div className="topspace">
        <div className="text-center">
          <div className="ambulance"><div className="bannertitleNew mediabannertitleNew">Ambulance</div></div>
          {/* <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/ambulance_banner-1-300x57.jpg" alt="What is Cancer" className="w-100"></img> */}
          <h1 className="bannertitle displayNone">Ambulance</h1>
        </div>
        <div className="contentBox">
          <div className="container">
            <h3 className="Bold28 mb20">Ambulance</h3>

            <ResourcesCommonComponent senderComponent="Ambulance" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Ambulance;
const getResouces = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : "?pageNumber=1&city=mumbai&state=maharashtra&location";
    console.log(searchParams);
    const resource = "ambulance";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getResources(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return {
      resources: responce.data.ResponseObject,
      totalRecords: responce.data.TotalRecords,
    };
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getLocation = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : null;
    console.log(searchParams);
    const resource = "ambulance";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getLocations(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return responce.data.ResponseObject;
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const loader = async ({ request, params }) => {
  // const url = new URL(request.url);
  return defer({
    data: await getResouces({ request, params }),
    locations: await getLocation({ request, params }),
  });
};
